import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Sign in with your new password.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <div className="relative min-h-screen bg-[#0B0F19] flex items-center justify-center px-4">
      <div className="absolute inset-0 canvas-dots opacity-40" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-xl">
        <h1 className="mb-4 text-2xl font-bold text-white font-display">Set a new password</h1>
        <form onSubmit={submit}>
          <input
            data-testid="reset-password-input"
            type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            className="mb-4 w-full rounded-xl border border-white/10 bg-white/10 px-4 py-3 text-white placeholder-slate-500 outline-none focus:border-violet-400"
          />
          <button data-testid="reset-submit-button" type="submit"
            className="w-full rounded-xl bg-gradient-to-r from-violet-500 to-pink-500 py-3 font-bold text-white">
            Reset password
          </button>
        </form>
        <Link to="/login" data-testid="back-to-login-link" className="mt-4 block text-center text-sm text-violet-300 hover:text-violet-200">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
